import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import CardProduto from '../../components/CardProd';
import api from '../../api';
import './index.scss';

export default function FavoritosPublico() {
  const { token } = useParams();
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const carregar = async () => {
      try {
        const response = await api.get(`/favoritos/publico/${token}`);
        if (response.data.success) {
          const itens = (response.data.data || []).map((fav) => ({
            id_variacao: fav.id_variacao,
            id: fav.id_produto,
            nome: fav.nome_produto,
            preco: fav.preco,
            estoque: fav.estoque,
            cor: fav.cor,
            tamanho: fav.tamanho,
            material: fav.material,
            tipo: fav.tipo,
            unidades_por_pacote: fav.unidades_por_pacote,
            imagem_principal: fav.imagem_principal
          }));
          setProdutos(itens);
        }
      } catch (error) {
        setProdutos([]);
      } finally {
        setLoading(false);
      }
    };

    carregar();
  }, [token]);

  return (
    <section className='container-favoritos-publico'>
      <Cabecalho />
      <main>
        <h1>Lista publica de favoritos</h1>
        {loading ? (
          <p>Carregando...</p>
        ) : produtos.length > 0 ? (
          <div className='lista-favoritos-publico'>
            {produtos.map((prod) => (
              <CardProduto key={`public-${prod.id_variacao}`} prod={prod} />
            ))}
          </div>
        ) : (
          <p>Esta lista esta vazia ou o link e invalido.</p>
        )}
      </main>
      <Rodape />
    </section>
  );
}
